import LogEntryView   from 'scripts/defa/log/view-log-entry-view';

/**
 * defa.views.LogEntryCollectionView
 * A view presenting a collection of log entries.
 * @version 1.2.0
 */
import CollectionView from 'scripts/poppet/collection-view';

const LogEntryCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: LogEntryView,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default LogEntryCollectionView;